export const FIRST_DATE = "1000-01-01";
export const LAST_DATE = "9999-12-31";

export function validDate(value: string): boolean {
  if (!/^[1-9]\d{3}-\d{2}-\d{2}$/.test(value)) return false;
  const time = Date.parse(`${value}T00:00:00Z`);
  return Number.isFinite(time) && new Date(time).toISOString().slice(0, 10) === value;
}

export function localToday(): string {
  const date = new Date();
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}

export function displayDate(value: string, long = false): string {
  if (!validDate(value)) return "";
  return new Date(`${value}T00:00:00Z`).toLocaleDateString("en-IN", {
    day: "numeric", month: long ? "long" : "short", year: "numeric", ...(long ? { weekday: "long" } as const : {}), timeZone: "UTC"
  });
}

export function inDateRange(value: string, min = FIRST_DATE, max = LAST_DATE): boolean {
  return validDate(value) && value >= min && value <= max;
}

export function clampDate(value: string, min = FIRST_DATE, max = LAST_DATE): string {
  const candidate = validDate(value) ? value : localToday();
  return candidate < min ? min : candidate > max ? max : candidate;
}

function dateKey(date: Date): string {
  return `${String(date.getUTCFullYear()).padStart(4, "0")}-${String(date.getUTCMonth() + 1).padStart(2, "0")}-${String(date.getUTCDate()).padStart(2, "0")}`;
}

export function addDays(value: string, days: number): string {
  const date = new Date(`${value}T00:00:00Z`);
  date.setUTCDate(date.getUTCDate() + days);
  return dateKey(date);
}

export function moveMonth(value: string, offset: number): string {
  const date = new Date(`${value}T00:00:00Z`);
  const day = date.getUTCDate();
  date.setUTCDate(1);
  date.setUTCMonth(date.getUTCMonth() + offset);
  const last = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 0)).getUTCDate();
  date.setUTCDate(Math.min(day, last));
  return dateKey(date);
}

export function monthDays(value: string): string[] {
  const first = `${value.slice(0, 7)}-01`;
  const mondayOffset = (new Date(`${first}T00:00:00Z`).getUTCDay() + 6) % 7;
  return Array.from({ length: 42 }, (_, index) => addDays(first, index - mondayOffset));
}
